import http from "./api";

const getApplications = ({ filterName, keyName, value }) => {
  return http.get(`Report/getReports?filter=${filterName}&${keyName}=${value}`);
};

export const ReportsSerice = {
  getApplications,
};
